import {json, type LoaderArgs} from '@shopify/remix-oxygen';
import {useLoaderData} from '@remix-run/react';
import invariant from 'tiny-invariant';
import {ProductCard, getPaginationVariables} from '~/components';
import {COLLECTION_CONTENT_QUERY} from '~/data/fragments';
import {getImageLoadingPriority} from '~/lib/const';
import {routeHeaders, CACHE_SHORT} from '~/data/cache';
import PageBanner from '~/components/Common/PageBanner';
import {fetchBranding} from '~/lib/storefrontFetcher';
import {findFieldsNode} from '~/utils';
import * as _ from 'lodash';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import {useGetContext} from '~/hooks/useGetContext';
import NavbarSection from '~/components/Sections/NavbarSection';

export const headers = routeHeaders;

export async function loader({request, context}: LoaderArgs) {
  const {storefront} = context;
  const branding = await fetchBranding({context});
  const collectionObject = _.get(
    findFieldsNode(branding, 'collections'),
    'value',
  );
  const collections = collectionObject ? JSON.parse(collectionObject) : [];

  const collectionProducts = await Promise.all(
    _.map(collections, (it) =>
      storefront.query(COLLECTION_CONTENT_QUERY, {
        variables: {
          id: it,
        },
      }),
    ),
  );

  invariant(collectionProducts, 'No data returned from Shopify API');

  return json(
    {
      collectionProducts,
      seo: {},
    },
    {
      headers: {
        'Cache-Control': CACHE_SHORT,
      },
    },
  );
}

function CollectionCard(collection: any) {
  const {
    collection: {products, id, title},
  } = collection;
  return (
    <div className="container">
      <AccordionItem uuid={id}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <span>{title}</span>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className="row">
            {products.nodes.map((product: any, i: any) => (
              <ProductCard
                key={product.id}
                product={product}
                loading={getImageLoadingPriority(i)}
                quickAdd
              />
            ))}
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    </div>
  );
}
export default function AllProducts() {
  const {collectionProducts} = useLoaderData<typeof loader>();
  const preExpanded = _.get(collectionProducts, '[0].collection.id');
  const {menuItems, logo, isAuthenticated} = useGetContext();
  return (
    <>
      <NavbarSection
        menuItems={menuItems}
        logo={logo || ''}
        title={'Products' || ''}
        isAuthenticated={isAuthenticated}
      />
      <PageBanner pageTitle="Products" />
      <div className="shop-area ptb-80">
        <div className="container">
          <div className="ro">
            <div className="faq-accordio">
              <Accordion preExpanded={[preExpanded || '']}>
                {_.map(collectionProducts, (item, i) => {
                  const {collection} = item;

                  return (
                    <CollectionCard
                      key={`${collection.id}-${i}`}
                      collection={collection}
                    />
                  );
                })}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
